/* eslint-disable no-unused-vars */
import "./App.css";
import LazyLoad from "react-lazyload";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import logo from "./irofullpng.webp";
import section1 from "./irosection1.png";
import TextField from "@mui/material/TextField";
import SendIcon from "@mui/icons-material/Send";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import CallMadeOutlinedIcon from "@mui/icons-material/CallMadeOutlined";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import KeyboardDoubleArrowRightOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowRightOutlined";
import CopyrightIcon from "@mui/icons-material/Copyright";
import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import { Link } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
/* eslint-enable no-unused-vars */
import { CONFIG } from "./config";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import LightModeIcon from "@mui/icons-material/LightMode";
import BedtimeIcon from "@mui/icons-material/Bedtime";
import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
import Grid from "@mui/material/Grid";
import { HashLink } from "react-router-hash-link";

import { useState, useEffect, forwardRef, Fragment } from "react";
import { Margin } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import { actionTypes } from "./reducer";
import { useStateValue } from "./StateProvider";
import "./Login.css";
import GoogleIcon from "@mui/icons-material/Google";
import AppleIcon from "@mui/icons-material/Apple";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AOS from "aos";

import Autocomplete from "@mui/material/Autocomplete";

// import { Popover, Transition } from '@headlessui/react'
// import { ChevronDownIcon, PhoneIcon, PlayCircleIcon } from '@heroicons/react/20/solid'
// import {
//   ArrowPathIcon,
//   ChartPieIcon,
//   CursorArrowRaysIcon,
//   FingerPrintIcon,
//   SquaresPlusIcon,
// } from '@heroicons/react/24/outline'

// const solutions = [
//   { name: 'Analytics', description: 'Get a better understanding of your traffic', href: '#', icon: ChartPieIcon },
//   { name: 'Engagement', description: 'Speak directly to your customers', href: '#', icon: CursorArrowRaysIcon },
//   { name: 'Security', description: "Your customers' data will be safe and secure", href: '#', icon: FingerPrintIcon },
//   { name: 'Integrations', description: 'Connect with third-party tools', href: '#', icon: SquaresPlusIcon },
//   { name: 'Automations', description: 'Build strategic funnels that will convert', href: '#', icon: ArrowPathIcon },
// ]
// const callsToAction = [
//   { name: 'Watch demo', href: '#', icon: PlayCircleIcon },
//   { name: 'Contact sales', href: '#', icon: PhoneIcon },
// ]

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Navbar() {
  const navigate = useNavigate();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const lightOrDarkSave =
    JSON.parse(localStorage.getItem("lightOrDarkSave")) || "light";
  const [theme, setTheme] = useState(lightOrDarkSave);
  const [open, setOpen] = useState(false);
  const [state, dispatch] = useStateValue();
  const [buttonTwo, setButtonTwo] = useState(true);
  const [buttonThree, setButtonThree] = useState(true);
  const [buttonFour, setButtonFour] = useState(true);
  const [age, setAge] = useState("");
  const [buttonFive, setButtonFive] = useState(true);
  const [buttonSix, setButtonSix] = useState(true);
  const [buttonSeven, setButtonSeven] = useState(true);
  const [buttonEight, setButtonEight] = useState(true);

  const [realbuttonclick, setRealbuttonclick] = useState(false);
  const [realbuttonclickk, setRealbuttonclickk] = useState(false);
  const [realbuttonclickkk, setRealbuttonclickkk] = useState(false);
  const [realbuttonclickkkk, setRealbuttonclickkkk] = useState(false);
  const [realbuttonclickkkkk, setRealbuttonclickkkkk] = useState(false);
  const [realbuttonclickkkkkk, setRealbuttonclickkkkkk] = useState(false);
  const [realbuttonclickkkkkkk, setRealbuttonclickkkkkkk] = useState(false);

  const toggleTheme = () => {
    if (theme === "light") {
      setTheme("dark");
      localStorage.setItem("lightOrDarkSave", JSON.stringify("dark"));
    } else {
      setTheme("light");
      localStorage.setItem("lightOrDarkSave", JSON.stringify("light"));
    }
  };
  useEffect(() => {
    document.documentElement.classList = theme;
  }, [theme]);

  useEffect(() => {
    AOS.init({ duration: 2000 }); //might need to be AOS
  }, []);

  const handleClose = () => {
    setOpen(false);
  };


  const handleClickOpen = () => {
    setOpen(true);
  };

  const AboutButton = () => {
    navigate("/about");
    setOpen(false);

    setButtonTwo(false);
    setButtonThree(false);
    setButtonFour(false);
    setButtonFive(true);
    setButtonSix(false);
    setButtonSeven(false);
    setButtonEight(false);
    setRealbuttonclickkkk(true);
    setRealbuttonclickkk(false);
    setRealbuttonclickk(false);
    setRealbuttonclick(false);
  };

  const rulesandreg = () => {
    navigate("/rules-and-regulations");
    handleClose(true);
  };

  const twentfinalist = () => {
    navigate("/finalists");
    handleClose(true);
  };
  const twentsemifinalist = () => {
    navigate("/semis-results");
    handleClose(true);
  };
  const twentsemiwinners = () => {
    navigate("/winners");
    handleClose(true);
  };
  const aboutexam = () => {
    navigate("/about-iro");
    handleClose(true);
  };
  const regreg = () => {
    navigate("/registration-and-eligibility");
    handleClose(true);
  };

  const letsgotwobut = () => {
    navigate("/about");
    handleClose(true);
  };

  const startclub = () => {
    navigate("/start-iro-club");
    handleClose(true);
  };
  const praticeexam = () => {
    navigate("/practice-exams");
    handleClose(true);
  };

  const scurriculssme = () => {
    navigate("/semi-curriculum");
    handleClose(true);
  };

  const curriculssme = () => {
    navigate("/curriculum");
    handleClose(true);
  };

  const studentAmbassador = () => {
    navigate("/forms/student-ambassador");
    handleClose(true);
  };

  const clubDirectory = () => {
    navigate("/directory");
    handleClose(true);
  };

  const clubPresentation = () => {
    navigate("/files/club-presentation-slides");
    handleClose(true);
  };

  const clubBylaws = () => {
    navigate("/files/club-bylaws");
    handleClose(true);
  };

  const peressrelase = () => {
    navigate("/press-releases");
    handleClose(true);
  };
  const indanews = () => {
    navigate("/iro-in-the-news");
    handleClose(true);
  };
  const medieakit = () => {
    navigate("/media-kit");
    handleClose(true);
  };
  const mediaeoutreach = () => {
    navigate("/media-contact");
    handleClose(true);
  };


  const IROExamInformation = () => {
    setButtonTwo(true);
    setButtonThree(false);
    setButtonFour(false);
    setButtonFive(false);
    setButtonSix(false);
    setButtonSeven(false);
    setButtonEight(false);
    setRealbuttonclick(true);
    setRealbuttonclickkkkkkk(false);
    setRealbuttonclickkkkkk(false);
    setRealbuttonclickkkkk(false);
    setRealbuttonclickkkk(false);
    setRealbuttonclickkk(false);
    setRealbuttonclickk(false);
  };
  const StudentCenter = () => {
    setButtonThree(true);
    setButtonTwo(false);
    setButtonFour(false);
    setButtonFive(false);
    setButtonSix(false);
    setButtonSeven(false);
    setButtonEight(false);
    setRealbuttonclickk(true);
    setRealbuttonclickkkkkkk(false);
    setRealbuttonclickkkkkk(false);
    setRealbuttonclickkkkk(false);
    setRealbuttonclickkkk(false);
    setRealbuttonclickkk(false);
    setRealbuttonclick(false);
  };
  const Media = () => {
    setButtonFour(true);
    setButtonTwo(false);
    setButtonThree(false);
    setButtonFive(false);
    setButtonSix(false);
    setButtonSeven(false);
    setButtonEight(false);
    setRealbuttonclickkk(true);

    setRealbuttonclickkkkkkk(false);
    setRealbuttonclickkkkkk(false);
    setRealbuttonclickkkkk(false);
    setRealbuttonclickkkk(false);

    setRealbuttonclickk(false);
    setRealbuttonclick(false);
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const signInButton = () => {
    window.open("https://exam.internationalresearcholympiad.org/", "_blank");
  };

  return (
    <div>
      <nav
        className="navbar"
        style={{
          backgroundColor: "white",
          borderBottom: "1px solid #e8eef3",
          padding: "12px 0",
        }}
      >
        <div className="container-fluid highlightnavbar">
          <a className="navbar-brand" href="/">
            <LazyLoad height={50} offset={100} once>
              <img
                src={logo}
                alt="Logo"
                width="46"
                className="d-inline-block align-text-top"
              />
            </LazyLoad>
          </a>
          <div className="d-flex" style={{ alignItems: "center", gap: "1px" }}>
            <button
              className="btn-sunbutton"
              type="submit"
              onClick={toggleTheme}
            >
              <div className="Icon-Transition">
                {theme !== "dark" ? (
                  <div className="Light-Icon-Transition">
                    <LightModeIcon style={{ fontSize: "17px" }} />
                  </div>
                ) : (
                  <div className="Dark-Icon-Transition">
                    <BedtimeIcon style={{ fontSize: "17px" }} />
                  </div>
                )}
              </div>
            </button>

            <button
              className="btn-Homebutton"
              type="submit"
              style={{ fontWeight: "500", fontSize: "15px" }}
            >
              <a href="/" style={{ color: "#1a1a2e", textDecoration: "none" }}>
                Home
              </a>
            </button>
            <button
              className="btn-aboutbutton"
              type="submit"
              onClick={AboutButton}
              style={{ fontWeight: "500", fontSize: "15px", color: "#1a1a2e" }}
            >
              About the IRO
            </button>
            <button
              className="btn-aboutbutton"
              type="submit"
              onClick={() => navigate("/winners-hub")}
              style={{ fontWeight: "500", fontSize: "15px", color: "#1a1a2e" }}
            >
              Winners
            </button>
            <button
              className="btn-aboutbutton"
              type="submit"
              onClick={() => navigate("/certificate")}
              style={{ fontWeight: "500", fontSize: "15px", color: "#1a1a2e" }}
            >
              Certificate
            </button>
            <button
              className="btn-aboutbutton"
              type="submit"
              onClick={() => navigate("/faq")}
              style={{ fontWeight: "500", fontSize: "15px", color: "#1a1a2e" }}
            >
              FAQ
            </button>
            <div class="btn-group">
              <button
                type="button"
                class="btn dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                IRO Exam Information
              </button>
              <ul style={{}} class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="/about-iro">
                    About the Exam
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/rules-and-regulations">
                    Rules and Regulations
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="registration-and-eligibility">
                    Registration and Eligibility
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/faq">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>

            <div class="btn-group">
              <button
                type="button"
                class="btn dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Student Center
              </button>
              <ul style={{}} class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="/forms/student-ambassador">
                    Student Ambassador Sign Up Form
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/start-iro-club">
                    How to Start an IRO Club
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/practice-exams">
                    Practice Exams
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/semi-curriculum">
                    Semi Exam Curriculum
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/curriculum">
                    Open Exam Curriculum
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/files/club-bylaws">
                    Research Club Bylaws
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="/files/club-presentation-slides"
                  >
                    Club Presentation Slides
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/directory">
                    Club Directory
                  </a>
                </li>
              </ul>
            </div>

            <div class="btn-group">
              <button
                type="button"
                class="btn dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Media
              </button>
              <ul style={{}} class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="/press-releases">
                    Press Releases
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/iro-in-the-news">
                    In the News
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/media-kit">
                    Media Kit + Branding
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="/media-contact">
                    Media Contact
                  </a>
                </li>

                {/* <HashLink to="/page#section-one">Section One</HashLink> */}
              </ul>
            </div>

            {/* <button className="btn-resourcesbutton" type="submit" onClick={ResourcesButton}>About the IRO</button>
            <button className="btn-resourcesbutton" type="submit" onClick={ResourcesButton}>IRO Exam Information</button>
            <button className="btn-resourcesbutton" type="submit" onClick={ResourcesButton}>Student Center</button>
            <button className="btn-resourcesbutton" type="submit" onClick={ResourcesButton}>Media</button> */}

            {/* <Popover className="relative">
                <Popover.Button className="inline-flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
                  <span>Solutions</span>
                  <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
                </Popover.Button>

                  <Popover.Panel className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-max -translate-x-1/2 px-4">
                    <div className="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
                      <div className="p-4">
                        {solutions.map((item) => (
                          <div key={item.name} className="group relative flex gap-x-6 rounded-lg p-4 hover:bg-gray-50">
                            <div className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                              <item.icon className="h-6 w-6 text-gray-600 group-hover:text-indigo-600" aria-hidden="true" />
                            </div>
                            <div>
                              <a href={item.href} className="font-semibold text-gray-900">
                                {item.name}
                                <span className="absolute inset-0" />
                              </a>
                              <p className="mt-1 text-gray-600">{item.description}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                      <div className="grid grid-cols-2 divide-x divide-gray-900/5 bg-gray-50">
                        {callsToAction.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            className="flex items-center justify-center gap-x-2.5 p-3 font-semibold text-gray-900 hover:bg-gray-100"
                          >
                            <item.icon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
                            {item.name}
                          </a>
                        ))}
                      </div>
                    </div>
                  </Popover.Panel>
               
              </Popover> */}

            <button onClick={handleClickOpen} className="btn-morebutton">
              {" "}
              <MenuOutlinedIcon style={{ color: "black" }} />{" "}
            </button>
            {/* Contact Email */}
            <button
              className="btn-contactbutton"
              style={{
                width: "130px",
                backgroundColor: "#004d99",
                fontWeight: "500",
              }}
              type="submit"
            >
              {" "}
              <a
                href={`mailto:${CONFIG.CONTACT_EMAIL}`}
                style={{ color: "white", textDecoration: "none" }}
              >
                Contact
              </a>{" "}
              <CallMadeOutlinedIcon
                style={{ fontSize: "15px", marginLeft: "2px" }}
              />
            </button>
            {/* <button className="btn-signInbutton" style={{width: "130px"}} type="submit" onClick={signInButton}>Sign In</button> */}

            {/* <div>
              <button className="btn-DensityMediumIconbutton" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight" type="submit"><DensityMediumIcon style={{color: 'black', fontSize: '20px'}}/></button>
              <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel" style={{ width: '100vw', height: '100vh' }}>
                <div class="offcanvas-header">
                  <h3 id="offcanvasRightLabel">More</h3>
                  <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ></button>
                </div>
                <div class="offcanvas-body">
                  <button className="side-bar-popover-button-css"  data-bs-dismiss="offcanvas" onClick={AboutButton} aria-label="Close" style={{color:'black'}}><NewspaperIcon style={{color:'black'}}/> About</button>
                  <button className="side-bar-popover-button-css"  data-bs-dismiss="offcanvas" onClick={ResourcesButton} aria-label="Close" style={{color:'black'}}><Diversity1Icon style={{color:'black'}}/> Resources</button>
                  <button className="side-bar-popover-button-css"><a href={`mailto:${CONFIG.CONTACT_EMAIL}`} style={{color: 'black', textDecoration: 'none' }}><ArrowOutwardOutlinedIcon/> Contact</a></button>
                  <button className="side-bar-popover-button-css" style={{ color: 'black'}} type="submit" onClick={() => navigate('/Login')}> Sign In</button>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </nav>
      <div className="coolhover-test"></div>

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{
            position: "relative",
            backgroundColor: "white",
            color: "black",
            boxShadow: "none",
          }}
          data-aos="fade-down"
          data-aos-duration="800"
        >
          <Toolbar>
            <Typography
              sx={{ ml: 4, flex: 1, marginTop: "20px" }}
              variant="h6"
              component="div"
            >
              <a class="navbar-brand" href="/">
                <LazyLoad height={100} offset={100} once>
                  <img
                    src={logo}
                    alt="Logo"
                    width="100"
                    className="d-inline-block align-text-top"
                  />
                </LazyLoad>
              </a>
            </Typography>
            <Button
              autoFocus
              color="inherit"
              onClick={handleClose}
              style={{
                textTransform: "none",
                marginTop: "20px",
                marginRight: "20px",
                padding: "8px 16px",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
              sx={{
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              <span style={{
                fontSize: "1rem",
                fontWeight: "500",
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                color: "#1a1a2e"
              }}>
                Close
              </span>
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  backgroundColor: "#f5f5f5",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background-color 0.2s ease",
                }}
              >
                <CloseIcon style={{ fontSize: "18px", color: "#1a1a2e" }} />
              </div>
            </Button>
          </Toolbar>
        </AppBar>

        <div className="mainscreenmenu">
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <List>
                <div data-aos="fade-down" data-aos-duration="500">
                  {buttonTwo ? (
                    <>
                      {realbuttonclick ? (
                        <button
                          className="side-bar-2-popover-button-csss underline-animationn"
                          style={{ color: "black" }}
                          onClick={IROExamInformation}
                        >
                          Exam Information
                        </button>
                      ) : (
                        <button
                          className="side-bar-2-popover-button-csss underline-animation"
                          style={{ color: "black" }}
                          onClick={IROExamInformation}
                        >
                          Exam Information
                        </button>
                      )}
                    </>
                  ) : (
                    <button
                      className="side-bar-2-popover-button-csss underline-animation"
                      style={{ color: "grey" }}
                      onClick={IROExamInformation}
                    >
                      Exam Information
                    </button>
                  )}

                  <br />
                  {buttonThree ? (
                    <>
                      {realbuttonclickk ? (
                        <button
                          className="side-bar-2-popover-button-css underline-animationn"
                          style={{ color: "black" }}
                          onClick={StudentCenter}
                        >
                          Student Center
                        </button>
                      ) : (
                        <button
                          className="side-bar-2-popover-button-css underline-animation"
                          style={{ color: "black" }}
                          onClick={StudentCenter}
                        >
                          Student Center
                        </button>
                      )}
                    </>
                  ) : (
                    <button
                      className="side-bar-2-popover-button-css underline-animation"
                      style={{ color: "grey" }}
                      onClick={StudentCenter}
                    >
                      Student Center
                    </button>
                  )}

                  <br />

                  {buttonFour ? (
                    <>
                      {realbuttonclickkk ? (
                        <button
                          className="side-bar-2-popover-button-css underline-animationn"
                          style={{ color: "black" }}
                          onClick={Media}
                        >
                          Media
                        </button>
                      ) : (
                        <button
                          className="side-bar-2-popover-button-css underline-animation"
                          style={{ color: "black" }}
                          onClick={Media}
                        >
                          Media
                        </button>
                      )}
                    </>
                  ) : (
                    <button
                      className="side-bar-2-popover-button-css underline-animation"
                      style={{ color: "grey" }}
                      onClick={Media}
                    >
                      Media
                    </button>
                  )}
                  <br />
                  <button
                    className="side-bar-2-popover-button-css underline-animation"
                    style={{ color: "black" }}
                    onClick={() => {
                      navigate("/winners-hub");
                      handleClose();
                    }}
                  >
                    Winners
                  </button>
                  <br />
                  <button
                    className="side-bar-2-popover-button-css underline-animation"
                    style={{ color: "black" }}
                    onClick={() => {
                      navigate("/certificate");
                      handleClose();
                    }}
                  >
                    Certificate
                  </button>
                  <br />
                  {buttonFive ? (
                    <>
                      {realbuttonclickkkk ? (
                        <button
                          className="side-bar-2-popover-button-css underline-animationn"
                          onClick={AboutButton}
                          style={{ color: "black" }}
                        >
                          About the IRO
                        </button>
                      ) : (
                        <button
                          className="side-bar-2-popover-button-css underline-animation"
                          onClick={AboutButton}
                          style={{ color: "black" }}
                        >
                          About the IRO
                        </button>
                      )}
                    </>
                  ) : (
                    <button
                      className="side-bar-2-popover-button-css underline-animation"
                      onClick={AboutButton}
                      style={{ color: "grey" }}
                    >
                      About the IRO
                    </button>
                  )}

                  {/* {buttonSix ? 
                <>
                  {realbuttonclickkkkk ?
                    <button className="side-bar-2-popover-button-css underline-animationn"  onClick={ResourcesButton} style={{color:'black'}}> Resources</button>
                  :
                    <button className="side-bar-2-popover-button-css underline-animation"  onClick={ResourcesButton} style={{color:'black'}}> Resources</button>
                  }
                </>
              :
                <button className="side-bar-2-popover-button-css underline-animation"  onClick={ResourcesButton} style={{color:'grey'}}> Resources</button>
              } */}
                  <br />
                  {buttonSeven ? (
                    <>
                      {realbuttonclickkkkkk ? (
                        <button className="side-bar-2-popover-button-css underline-animationn">
                          <a
                            href={`mailto:${CONFIG.CONTACT_EMAIL}`}
                            style={{ color: "black", textDecoration: "none" }}
                          >
                            Contact
                          </a>
                        </button>
                      ) : (
                        <button className="side-bar-2-popover-button-css underline-animation">
                          <a
                            href={`mailto:${CONFIG.CONTACT_EMAIL}`}
                            style={{ color: "black", textDecoration: "none" }}
                          >
                            Contact
                          </a>
                        </button>
                      )}
                    </>
                  ) : (
                    <button className="side-bar-2-popover-button-css underline-animation">
                      <a
                        href={`mailto:${CONFIG.CONTACT_EMAIL}`}
                        style={{ color: "grey", textDecoration: "none" }}
                      >
                        Contact
                      </a>
                    </button>
                  )}
                  {/* <br/> */}
                  {/* {buttonEight ? 
                <>
                  {realbuttonclickkkkkkk ?
                    <button className="side-bar-2-popover-button-css underline-animationn" style={{ color: 'black'}} type="submit" onClick={signInButton}> Sign In</button>
                  :
                    <button className="side-bar-2-popover-button-css underline-animation" style={{ color: 'black'}} type="submit" onClick={signInButton}> Sign In</button>
                  }
                </>
              :
                <button className="side-bar-2-popover-button-css underline-animation" style={{ color: 'grey'}} type="submit" onClick={signInButton}> Sign In</button>
              } */}

                  <br />
                </div>
              </List>
            </Grid>
            {/* THis will be second col */}
            <Grid item xs={6}>
              <List>
                <div>
                  {realbuttonclick && (
                    <div
                      style={{ paddingTop: "30px" }}
                      data-aos="fade-right"
                      data-aos-duration="500"
                    >
                      <p className="iei-title">IRO Exam Information</p>
                      <p className="iei-summary">
                        Explore key details of the International Research
                        Olympiad (IRO) exam, <br /> including registration
                        deadlines, exam format, and syllabus. It's an essential
                        resource for students.
                      </p>
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={aboutexam}
                      >
                        About the Exam{" "}
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />{" "}
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={rulesandreg}
                      >
                        Rules and Regulations: ToS, Privacy Policy, Honor
                        Code{" "}
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />{" "}
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={regreg}
                      >
                        Registration and Eligibility{" "}
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={() => {
                          navigate("/faq");
                          handleClose(true);
                        }}
                      >
                        FAQ{" "}
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />
                    </div>
                  )}
                  {realbuttonclickk && (
                    <div data-aos="fade-right" data-aos-duration="500">
                      <p className="iei-title">IRO Student Center</p>
                      <p className="iei-summary">
                        Student hub for the IRO of{""}fering resources for
                        starting IRO clubs, accessing practice exams, and
                        curriculum guidance, including literature review
                        tutorials and instructional videos.
                      </p>
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={studentAmbassador}
                      >
                        Student Ambassador Sign Up Form
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />{" "}
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={startclub}
                      >
                        How to Start an IRO Club
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />{" "}
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={praticeexam}
                      >
                        Practice Exams
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />{" "}
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={scurriculssme}
                      >
                        Semi Exam Curriculum
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />{" "}
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={curriculssme}
                      >
                        Open Exam Curriculum{" "}
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={clubBylaws}
                      >
                        Research Club Bylaws{" "}
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={clubPresentation}
                      >
                        Club Presentation Slides{" "}
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />
                      <br />
                      <br />
                      <button
                        className="lowertitle secondinsideytwo underline-animation"
                        style={{ color: "black" }}
                        type="submit"
                        onClick={clubDirectory}
                      >
                        Club Directory{" "}
                      </button>
                      <ArrowForwardIcon style={{ marginBottom: "4px" }} />
                    </div>
                  )}
                  {realbuttonclickkk && (
                    <div data-aos="fade-right" data-aos-duration="500">
                      <div data-aos="fade-right" data-aos-duration="500">
                        <p className="iei-title">Media Opportunities</p>
                        <p className="iei-summary">
                          Explore resources for journalists and the public,
                          featuring Press Releases, IRO-related news coverage, a
                          comprehensive Media Kit with branding guidelines, and
                          a Contact section for media inquiries.
                        </p>
                        <br />
                        <button
                          className="lowertitle secondinsideytwo underline-animation"
                          style={{ color: "black" }}
                          type="submit"
                          onClick={peressrelase}
                        >
                          Press Releases
                        </button>
                        <ArrowForwardIcon style={{ marginBottom: "4px" }} />{" "}
                        <br />
                        <br />
                        <button
                          className="lowertitle secondinsideytwo underline-animation"
                          style={{ color: "black" }}
                          type="submit"
                          onClick={indanews}
                        >
                          IRO in the News
                        </button>
                        <ArrowForwardIcon style={{ marginBottom: "4px" }} />{" "}
                        <br />
                        <br />
                        <button
                          className="lowertitle secondinsideytwo underline-animation"
                          style={{ color: "black" }}
                          type="submit"
                          onClick={medieakit}
                        >
                          Media Kit + Branding
                        </button>
                        <ArrowForwardIcon style={{ marginBottom: "4px" }} />
                        <br />
                        <br />
                        <button
                          className="lowertitle secondinsideytwo underline-animation"
                          style={{ color: "black" }}
                          type="submit"
                          onClick={mediaeoutreach}
                        >
                          Contact
                        </button>
                        <ArrowForwardIcon style={{ marginBottom: "4px" }} />
                      </div>
                    </div>
                  )}
                </div>
              </List>
            </Grid>
          </Grid>
        </div>

        {/* small screen */}

        <div className="smallscreenmenu">
          <div style={{ margin: "30px 30px" }}>
            {/* Main menu items */}
            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              {/* 1. About the IRO */}
              <button
                style={{
                  color: "#1a1a2e",
                  display: "block",
                  padding: "12px 0",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  letterSpacing: "-0.01em",
                  background: "none",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  borderBottom: "1px solid #f0f0f0"
                }}
                onClick={letsgotwobut}
              >
                About the IRO
              </button>

              {/* 2. Eligibility */}
              <button
                style={{
                  color: "#1a1a2e",
                  display: "block",
                  padding: "12px 0",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  letterSpacing: "-0.01em",
                  background: "none",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  borderBottom: "1px solid #f0f0f0"
                }}
                onClick={regreg}
              >
                Eligibility
              </button>

              {/* 3. About the Exam */}
              <button
                style={{
                  color: "#1a1a2e",
                  display: "block",
                  padding: "12px 0",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  letterSpacing: "-0.01em",
                  background: "none",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  borderBottom: "1px solid #f0f0f0"
                }}
                onClick={aboutexam}
              >
                About the Exam
              </button>

              {/* 4. Rules and Regulations */}
              <button
                style={{
                  color: "#1a1a2e",
                  display: "block",
                  padding: "12px 0",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  letterSpacing: "-0.01em",
                  background: "none",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  borderBottom: "1px solid #f0f0f0"
                }}
                onClick={rulesandreg}
              >
                Rules and Regulations
              </button>

              {/* 5. FAQs */}
              <button
                style={{
                  color: "#1a1a2e",
                  display: "block",
                  padding: "12px 0",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  letterSpacing: "-0.01em",
                  background: "none",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  borderBottom: "1px solid #f0f0f0"
                }}
                onClick={() => {
                  navigate("/faq");
                  handleClose(true);
                }}
              >
                FAQs
              </button>

              {/* 6. View Past Winners */}
              <button
                style={{
                  color: "#1a1a2e",
                  display: "block",
                  padding: "12px 0",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                  letterSpacing: "-0.01em",
                  background: "none",
                  border: "none",
                  textAlign: "left",
                  cursor: "pointer",
                  borderBottom: "1px solid #f0f0f0"
                }}
                onClick={() => {
                  navigate("/winners-hub");
                  handleClose(true);
                }}
              >
                View Past Winners
              </button>

              {/* 7. Start an IRO Club (with Media Kit) */}
              <div style={{ borderBottom: "1px solid #f0f0f0" }}>
                <button
                  style={{
                    color: "#1a1a2e",
                    display: "block",
                    padding: "12px 0 8px 0",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    letterSpacing: "-0.01em",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer"
                  }}
                  onClick={startclub}
                >
                  Start an IRO Club
                </button>
                <button
                  style={{
                    color: "#666",
                    display: "block",
                    padding: "6px 0 12px 16px",
                    fontSize: "0.95rem",
                    fontWeight: "500",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer"
                  }}
                  onClick={medieakit}
                >
                  → Media Kit
                </button>
              </div>

              {/* 8. Exam Preparation Material */}
              <div style={{ borderBottom: "1px solid #f0f0f0" }}>
                <button
                  style={{
                    color: "#1a1a2e",
                    display: "block",
                    padding: "12px 0 8px 0",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    letterSpacing: "-0.01em",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer"
                  }}
                  onClick={praticeexam}
                >
                  Exam Preparation Material
                </button>
                <button
                  style={{
                    color: "#666",
                    display: "block",
                    padding: "6px 0 6px 16px",
                    fontSize: "0.95rem",
                    fontWeight: "500",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer"
                  }}
                  onClick={praticeexam}
                >
                  → Practice Exams
                </button>
                <button
                  style={{
                    color: "#666",
                    display: "block",
                    padding: "6px 0 6px 16px",
                    fontSize: "0.95rem",
                    fontWeight: "500",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer"
                  }}
                  onClick={curriculssme}
                >
                  → Open Exam Curriculum
                </button>
                <button
                  style={{
                    color: "#666",
                    display: "block",
                    padding: "6px 0 12px 16px",
                    fontSize: "0.95rem",
                    fontWeight: "500",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer"
                  }}
                  onClick={scurriculssme}
                >
                  → Semi Exam Curriculum
                </button>
              </div>

              {/* 9. Media Coverage */}
              <div style={{ borderBottom: "1px solid #f0f0f0" }}>
                <p
                  style={{
                    color: "#1a1a2e",
                    padding: "12px 0 8px 0",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    letterSpacing: "-0.01em",
                    margin: 0
                  }}
                >
                  Media Coverage
                </p>
                <button
                  style={{
                    color: "#666",
                    display: "block",
                    padding: "6px 0 6px 16px",
                    fontSize: "0.95rem",
                    fontWeight: "500",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer"
                  }}
                  onClick={indanews}
                >
                  → Press Coverage
                </button>
                <button
                  style={{
                    color: "#666",
                    display: "block",
                    padding: "6px 0 12px 16px",
                    fontSize: "0.95rem",
                    fontWeight: "500",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                    background: "none",
                    border: "none",
                    textAlign: "left",
                    cursor: "pointer"
                  }}
                  onClick={peressrelase}
                >
                  → Press Releases
                </button>
              </div>
            </div>

          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default Navbar;
